/**
 * Wishlist King / Swish renders product.title (often the SKU).
 * - Patch visible titles to Display Title (custom.display_title)
 * - Inject paperclip copy button next to each title
 * - Override "Copy Favorite Products" clipboard to linked "SKU: XXX, Display Title"
 */
(function () {
  const META_CACHE = new Map();
  const PENDING = new Map();
  let observerStarted = false;
  let patchTimer = null;
  let patching = false;
  let clickHooked = false;

  const COPY_ICON_SVG = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M1.96286 16.0373C2.38255 16.4576 2.88116 16.7908 3.43003 17.0179C3.97891 17.2449 4.56723 17.3612 5.16119 17.3601C5.75528 17.3611 6.34373 17.2448 6.89275 17.0178C7.44176 16.7908 7.94054 16.4576 8.36043 16.0373L10.9191 13.4778L9.63976 12.1984L7.08109 14.758C6.57123 15.2656 5.88108 15.5505 5.16164 15.5505C4.4422 15.5505 3.75205 15.2656 3.24219 14.758C2.73417 14.2484 2.4489 13.5581 2.4489 12.8385C2.4489 12.119 2.73417 11.4287 3.24219 10.9191L5.80176 8.36043L4.52243 7.08109L1.96286 9.63976C1.11582 10.4888 0.640137 11.6392 0.640137 12.8385C0.640137 14.0379 1.11582 15.1883 1.96286 16.0373V16.0373ZM16.0373 8.36043C16.8839 7.51111 17.3593 6.36083 17.3593 5.16164C17.3593 3.96245 16.8839 2.81217 16.0373 1.96286C15.1883 1.11582 14.0379 0.640137 12.8385 0.640137C11.6392 0.640137 10.4888 1.11582 9.63976 1.96286L7.08109 4.52243L8.36043 5.80176L10.9191 3.24219C11.429 2.73461 12.1191 2.44964 12.8385 2.44964C13.558 2.44964 14.2481 2.73461 14.758 3.24219C15.266 3.75182 15.5513 4.44205 15.5513 5.16164C15.5513 5.88123 15.266 6.57147 14.758 7.08109L12.1984 9.63976L13.4778 10.9191L16.0373 8.36043Z" fill="black"/>
    <path d="M5.80075 13.4786L4.52051 12.1993L12.1992 4.52148L13.4786 5.80172L5.80075 13.4786Z" fill="black"/>
  </svg>`;

  function getHandleFromHref(href) {
    const match = String(href || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function fetchProductMeta(handle) {
    if (!handle) return Promise.resolve(null);
    if (META_CACHE.has(handle)) return Promise.resolve(META_CACHE.get(handle));
    if (PENDING.has(handle)) return PENDING.get(handle);

    const request = fetch(`/products/${encodeURIComponent(handle)}?view=display-title`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const meta = {
          handle,
          title: data && data.title ? String(data.title).trim() : '',
          sku: data && data.sku ? String(data.sku).trim() : '',
        };
        META_CACHE.set(handle, meta);
        PENDING.delete(handle);
        return meta;
      })
      .catch(() => {
        PENDING.delete(handle);
        return null;
      });

    PENDING.set(handle, request);
    return request;
  }

  function getWishlistRoots() {
    return Array.from(document.querySelectorAll('wishlist-page'));
  }

  function getTitleLinks(root) {
    return Array.from(
      root.querySelectorAll(
        '.product-title a[href*="/products/"], .h6.name_wrapper a[href*="/products/"]'
      )
    ).filter((link) => !link.classList.contains('product__copy-text'));
  }

  function getProductHandles(root) {
    const handles = [];
    const seen = new Set();

    getTitleLinks(root).forEach((link) => {
      const handle = getHandleFromHref(link.getAttribute('href') || link.href);
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      handles.push(handle);
    });

    if (!handles.length) {
      root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        if (link.classList.contains('product__copy-text')) return;
        const handle = getHandleFromHref(link.getAttribute('href') || link.href);
        if (!handle || seen.has(handle)) return;
        seen.add(handle);
        handles.push(handle);
      });
    }

    return handles;
  }

  function ensureCopyPopup() {
    let popup = document.querySelector('.product-link-copy-popup');
    if (popup) return popup;

    popup = document.createElement('div');
    popup.className = 'product-link-copy-popup';
    popup.innerHTML = '<span>Link Copied</span>';
    document.body.appendChild(popup);
    return popup;
  }

  function showCopyPopup() {
    const popup = ensureCopyPopup();
    popup.classList.add('product-link-copy-popup_show');
    setTimeout(() => popup.classList.remove('product-link-copy-popup_show'), 2000);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function productUrl(handle, href) {
    if (href) {
      try {
        return new URL(href, window.location.origin).href;
      } catch (e) {
        // fall through
      }
    }
    return `${window.location.origin}/products/${handle}`;
  }

  function formatLine(meta) {
    const sku = meta.sku || '';
    const title = meta.title || '';

    if (sku && title) return `SKU: ${sku}, ${title}`;
    if (title) return title;
    if (sku) return `SKU: ${sku}`;
    return '';
  }

  function ensureCopyControls(link, meta) {
    const wrapper =
      link.closest('.product-title, .h6.name_wrapper, .name_wrapper') ||
      link.parentElement;
    if (!wrapper) return;

    const handle = meta.handle;
    const label = formatLine(meta);
    const href = productUrl(handle, link.getAttribute('href') || link.href);

    let copyText = wrapper.querySelector('a.product__copy-text');
    if (!copyText) {
      copyText = document.createElement('a');
      copyText.className = 'product__copy-text';
      copyText.style.cssText =
        'color: rgb(64, 64, 177); font-weight: 400; font-size: 12px; text-decoration: underline; text-decoration-color: black; position: absolute; transform: translateX(90000px);';
      wrapper.insertBefore(copyText, wrapper.firstChild);
    }
    copyText.href = href;
    copyText.textContent = label || meta.title || '';
    copyText.setAttribute('data-handle', handle);

    let actions = wrapper.querySelector('.product-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'product-actions';
      wrapper.appendChild(actions);
    }

    let btn = actions.querySelector('.product__copy-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__copy-btn';
      btn.setAttribute('aria-label', 'Copy product link');
      btn.innerHTML = `${COPY_ICON_SVG}<span class="product__text-on-hover">Copy product link</span>`;
      actions.appendChild(btn);
    }

    btn.setAttribute('data-handle', handle);

    // Keep title row aligned with collection cards
    if (getComputedStyle(wrapper).display === 'inline') {
      wrapper.style.display = 'inline-flex';
      wrapper.style.alignItems = 'center';
      wrapper.style.flexWrap = 'wrap';
      wrapper.style.gap = '6px';
    }
  }

  async function patchWishlistTitles(root) {
    const links = getTitleLinks(root);
    if (!links.length) return;

    patching = true;
    try {
      await Promise.all(
        links.map(async (link) => {
          const handle = getHandleFromHref(link.getAttribute('href') || link.href);
          if (!handle) return;

          const meta = await fetchProductMeta(handle);
          if (!meta) return;

          const displayTitle = meta.title || '';
          if (displayTitle && link.textContent.trim() !== displayTitle) {
            link.textContent = displayTitle;
          }

          ensureCopyControls(link, meta);
        })
      );
    } finally {
      patching = false;
    }
  }

  function schedulePatch(root) {
    if (patching) return;
    clearTimeout(patchTimer);
    patchTimer = setTimeout(() => {
      getWishlistRoots().forEach((page) => {
        patchWishlistTitles(page);
      });
      if (root && root.tagName === 'WISHLIST-PAGE') {
        patchWishlistTitles(root);
      }
    }, 80);
  }

  function isCopyFavoritesButton(target) {
    const button = target?.closest?.('button');
    if (!button) return false;
    if (button.classList.contains('product__copy-btn')) return false;

    const aria = (button.getAttribute('aria-label') || '').toLowerCase();
    if (aria.includes('share favorite') || aria.includes('copy favorite')) return true;

    const text = (button.textContent || '').toLowerCase();
    if (text.includes('copy favorite products') || text.includes('share favorite products')) {
      return true;
    }

    return Boolean(button.closest('.wishlist-share-products'));
  }

  async function buildCopyPayload(root) {
    const handles = getProductHandles(root);
    if (!handles.length) return null;

    const plainLines = [];
    const htmlLines = [];

    for (const handle of handles) {
      const meta = await fetchProductMeta(handle);
      if (!meta) continue;

      const label = formatLine(meta);
      if (!label) continue;

      const href = productUrl(handle);
      plainLines.push(`${label}\n${href}`);
      htmlLines.push(`<div><a href="${escapeHtml(href)}">${escapeHtml(label)}</a></div>`);
    }

    if (!plainLines.length) return null;

    return {
      plain: plainLines.join('\n\n'),
      html: htmlLines.join(''),
    };
  }

  async function writeClipboard(plain, html) {
    try {
      if (navigator.clipboard?.write && window.ClipboardItem && html) {
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/plain': new Blob([plain], { type: 'text/plain' }),
            'text/html': new Blob([html], { type: 'text/html' }),
          }),
        ]);
        showCopyPopup();
        return true;
      }

      await navigator.clipboard.writeText(plain);
      showCopyPopup();
      return true;
    } catch (error) {
      console.warn('[wishlist-display-title] clipboard failed', error);
      try {
        await navigator.clipboard.writeText(plain);
        showCopyPopup();
        return true;
      } catch (fallbackError) {
        console.warn('[wishlist-display-title] plain clipboard failed', fallbackError);
        return false;
      }
    }
  }

  async function copyFavorites(button) {
    const root = button.closest('wishlist-page') || getWishlistRoots()[0];
    if (!root) return false;

    const payload = await buildCopyPayload(root);
    if (!payload) return false;

    return writeClipboard(payload.plain, payload.html);
  }

  async function copySingleProduct(button) {
    const handle =
      button.getAttribute('data-handle') ||
      button.closest('.product-title, .name_wrapper')?.querySelector('[data-handle]')?.getAttribute('data-handle') ||
      getHandleFromHref(
        button.closest('.product-title, .name_wrapper')?.querySelector('a[href*="/products/"]')?.getAttribute('href')
      );

    if (!handle) return false;

    const meta = await fetchProductMeta(handle);
    if (!meta) return false;

    const label = formatLine(meta);
    const href = productUrl(
      handle,
      button.closest('.product-title, .name_wrapper')?.querySelector('a[href*="/products/"]')?.getAttribute('href')
    );
    if (!label) return false;

    const html = `<a href="${escapeHtml(href)}">${escapeHtml(label)}</a>`;
    return writeClipboard(label, html);
  }

  function hookClicks() {
    if (clickHooked) return;
    clickHooked = true;

    document.addEventListener(
      'click',
      (event) => {
        const singleBtn = event.target.closest('wishlist-page .product__copy-btn');
        if (singleBtn) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          copySingleProduct(singleBtn);
          return;
        }

        if (!isCopyFavoritesButton(event.target)) return;

        const button = event.target.closest('button') || event.target;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        copyFavorites(button);
      },
      true
    );
  }

  function watchWishlistPage(page) {
    if (!page || page.dataset.displayTitleWatching === 'true') return;
    page.dataset.displayTitleWatching = 'true';

    schedulePatch(page);

    const observer = new MutationObserver(() => {
      if (patching) return;
      schedulePatch(page);
    });

    observer.observe(page, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    hookClicks();
    ensureCopyPopup();
    getWishlistRoots().forEach(watchWishlistPage);

    if (observerStarted) return;
    observerStarted = true;

    const docObserver = new MutationObserver(() => {
      getWishlistRoots().forEach(watchWishlistPage);
    });

    docObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
